export let appInitTime = Date.now()

export const isAppRecentlyLaunched = () => {
   const timeSinceInit = Date.now() - appInitTime
   return timeSinceInit < 3000
}

export const resetAppInitTime = () => {
   appInitTime = Date.now()
}
